var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"alert"},[_c('button',{staticClass:"closebtn",on:{"click":_vm.closeBoton}},[_vm._v("×")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('price_Alert')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }